import { Provider } from 'react-redux';
import { store } from './store';
import { Router } from './pages';
import { ToastProvider } from './providers';
import { SolanaWalletProvider } from './components/SolanaWalletProvider';

export const App = () => {
  return (
    <Provider store={store}>
      <ToastProvider defaultPosition="top-right">
        <SolanaWalletProvider>
          <Router />
        </SolanaWalletProvider>
      </ToastProvider>
    </Provider>
  );
};
